import { SubText, Table } from '@procurify/ui'
import { useIntl } from 'react-intl'

import messages from './messages'
import { ExportPreviewStyled } from './styles/ExportPreviewStyled'

export interface IExportPreviewProps {
  sampleData?: string[][]
}

export const ExportPreview = ({ sampleData = [] }: IExportPreviewProps) => {
  const intl = useIntl()

  // Take a maximum of 5 sample data rows
  const sampleDataValues = [...sampleData].splice(1, 5)

  return (
    <ExportPreviewStyled>
      <Table>
        {sampleData?.[0]?.length > 0 && (
          <Table.Head>
            <Table.Row>
              {sampleData[0].map((cell, cellIndex) => (
                <Table.Cell key={cellIndex}>{cell}</Table.Cell>
              ))}
            </Table.Row>
          </Table.Head>
        )}
        {sampleDataValues?.length > 0 ? (
          <Table.Body>
            <>
              {sampleDataValues.map((sampleRows, index) => (
                <Table.Row key={index}>
                  {sampleRows.map((cell, cellIndex) => (
                    <Table.Cell key={cellIndex}>{cell}</Table.Cell>
                  ))}
                </Table.Row>
              ))}
              {5 - sampleDataValues.length > 0 &&
                new Array(5 - sampleDataValues.length)
                  .fill(null)
                  .map((_, index) => (
                    <Table.Row key={index}>
                      {new Array(sampleDataValues[0].length)
                        .fill(null)
                        .map((__, cellIndex) => (
                          <Table.Cell key={cellIndex}>&nbsp;</Table.Cell>
                        ))}
                    </Table.Row>
                  ))}
            </>
          </Table.Body>
        ) : (
          <Table.Body>
            <>
              {new Array(3).fill(null).map((_, index) => (
                <Table.Row key={index}>
                  <Table.Cell colSpan={99}>&nbsp;</Table.Cell>
                </Table.Row>
              ))}
            </>
          </Table.Body>
        )}
      </Table>

      {sampleDataValues.length === 0 && (
        <div className='sample-data-overlay'>
          <div>
            <SubText bold>
              {intl.formatMessage(messages.emptyStateLineOne)}
            </SubText>
            <SubText>{intl.formatMessage(messages.emptyStateLineTwo)}</SubText>
          </div>
        </div>
      )}

      {sampleDataValues.length > 0 && (
        <div className='sample-data-overlay'>
          <SubText bold>
            {intl.formatMessage(messages.previewOverlayText)}
          </SubText>
        </div>
      )}
    </ExportPreviewStyled>
  )
}

ExportPreview.displayName = 'ExportPreview'
